import React from "react";
import { Badge } from "common/components";
const hasRiskScore = (riskScore) => riskScore !== null && riskScore !== void 0;
const getRiskScoreStyle = (riskScore) => {
  if (!hasRiskScore(riskScore) || riskScore < 25) return "default";
  if (riskScore < 50) return "info";
  if (riskScore < 75) return "warning";
  return "danger";
};
const RiskScoreBadge = ({ riskScore, size = "sm" }) => {
  const riskScoreStr = hasRiskScore(riskScore) ? riskScore.toFixed(1) : "N/A";
  return /* @__PURE__ */ React.createElement(Badge, { size, variant: getRiskScoreStyle(riskScore), title: `Risk score: ${riskScoreStr}` }, riskScoreStr);
};
export default RiskScoreBadge;
